"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeyAuthMissingInSpecError = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "ApiKeyAuthMissingInSpec";
const messageKey = "driver.apiKey.error.authMissingInSpec";
class ApiKeyAuthMissingInSpecError extends teamsfx_api_1.UserError {
    constructor(actionName, authName) {
        super({
            source: actionName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey, authName),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, authName),
        });
    }
}
exports.ApiKeyAuthMissingInSpecError = ApiKeyAuthMissingInSpecError;
//# sourceMappingURL=apiKeyAuthMissingInSpec.js.map